import { IViewSolarRecommendations } from "../dtos/response-dtos/view-solar-estimation-response-dto";
import { EViewSolarEstimationSolarProductCategory } from "../enums/view-solar-estimation-solar-product-category";

const sortSolarComponentOrder: Record<
  EViewSolarEstimationSolarProductCategory,
  number
> = {
  [EViewSolarEstimationSolarProductCategory.INVERTERS]: 1,
  [EViewSolarEstimationSolarProductCategory.BATTERIES]: 2,
  [EViewSolarEstimationSolarProductCategory.PANELS]: 3,
  [EViewSolarEstimationSolarProductCategory.CHARGE_CONTROLLERS]: 4,
  [EViewSolarEstimationSolarProductCategory.WATER_HEATERS]: 5,
  [EViewSolarEstimationSolarProductCategory.WATER_HEATER_CONTROLLERS]: 6,
};

export function sortRecommendations(
  arr: IViewSolarRecommendations[],
): IViewSolarRecommendations[] {
  return [...arr].sort(
    (a, b) =>
      sortSolarComponentOrder[a.category] - sortSolarComponentOrder[b.category],
  );
}
